import { useResourceFormData } from "src/components/Form/hooks/useResourceFormData.ts";
import type { EditDocumentFormData } from "src/admin/modules/document/forms/document/config.tsx";
import { LettersTabPage } from "src/admin/epost-letters/LettersTabPage.tsx";

/** Вкладка «Per Post»: письма, где документ источник или лежит за Anschreiben. */
export const DocumentLetters = () => {
  const document = useResourceFormData<EditDocumentFormData>()?.data;

  if (!document?.id) {
    return null;
  }

  return (
    <LettersTabPage
      filter={[{ field: "document_id", operator: "is", value: document.id }]}
      wizard={{ document_id: document.id }}
    />
  );
};
